import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { PageTemplateTable } from '../../../directives/page-template-table/page-template-table';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ResellerType, ResellerRequestSearch } from '../../../models/api-store/reseller/reseller.request.model';
import { FloatingItem } from '../../ui/floatingbar/floatingbar-item';
import { ResellerService } from '../../../services/api-store/reseller/reseller.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SpinnerService } from '../../../services/spinner/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { ResellerEditComponent } from './reseller-edit/reseller-edit.component';
import { ResellerResponse } from '../../../models/api-store/reseller/reseller.response.model';
import { ResellerCreateComponent } from './reseller-create/reseller-create.component';
import { ActionConfirmComponent } from '../../ui/actionconfirm/actionconfirm.component';
import { ActionConfirmModel } from '../../../models/action-confirm.model';
import { DIALOG_LARGE_CONFIG, DIALOG_MEDIUM_CONFIG } from '../../../utils/config/modal-settings';
import { TRUE } from '../../../utils/config/const';

@Component({
  selector: 'app-reseller',
  templateUrl: './reseller.component.html',
  styleUrls: ['./reseller.component.css']
})
export class ResellerComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {

  searchFilterForm: FormGroup;
  request: any = {};
  typeSettings = {};
  selectedType = [];
  isEmpty: boolean = false;
  public isSearching: boolean = false;
  typeList = [
    { value: ResellerType.FRANCHISING },
    { value: ResellerType.MONOBRAND },
  ];

  /* Configura i button della floatingbar */
  public menuItems: FloatingItem[] = [
    {
      title: '',
      icon: 'fas fa-upload',
      choice: 'CREATE'
    }
  ];


  constructor(
    private resellerService: ResellerService,
    private domSanitizer: DomSanitizer,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    public modalService: NgbModal
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: ''
    });
  }

  _typeSettings() {
    return {
      singleSelection: true,
      enableCheckAll: false,
      primaryKey: 'value',
      labelKey: 'value',
      searchBy: ['value'],
      showCheckbox: window.name,
      classes: 'form-control topic-select',
      lazyLoading: false,
      text: 'Tipologia',
      noDataLabel: 'Nessuna risultato con la ricerca associata',
      searchAutofocus: true,
      badgeShowLimit: 4
    };
  };

  /**
* Inizializza la tabella
*/
  initTable() {
    const that = this;
    this.initCommon_dtOptions();
    this.dtOptions['columnDefs'] = [
      {orderable: false,targets: 0,width:'20%'},
      {orderable: false,targets: 1,width:'35%'},
      {orderable: false,targets: 2,width:'35%'},
      {orderable: false,targets: 3,width:'10%'}
    ];
    this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
      this.isSearching = true;
      
      if (dataTablesParameters.start > 0) {
        dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
      }
      that.numeroPagina = dataTablesParameters.start;
      that.dimPagina = dataTablesParameters.length;
      let resellerRequestSearch = that.getFilter();
      that.resellerService.search(resellerRequestSearch).subscribe(
        (response) => {
          if(response != null){
            if (response.data.length == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            that.setListEntityList(response);
            callback({
              recordsTotal: response.total,
              recordsFiltered: response.total,
              data: []
            });
          }else{
            this.isEmpty = false;
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          } 
          that.spinner.hide();
          that.isSearching = false;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          that.spinner.hide();
          that.isSearching = false;
        }
      );
    }
  }

  ngOnInit() {
    
    this.initTable();
    this.getSettings();
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  /**
  * Click sulla lente per la ricerca
  */
  clickSearch() {
    this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
    this.resetFilter();
    this.ajaxReload();
  }


  filterSelect() {
    this.resetFilter();
    this.ajaxReload();
  }

  toggleCheckBoxes(elementToToggle) {
    let value = this.searchFilterForm.controls[elementToToggle].value
    this.searchFilterForm.controls[elementToToggle].setValue(!value);
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.value !== elementToToggle && item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
      if (i === listOfCheckboxes.length - 1) {
        this.changeFilter();
      }
    })
  }

  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.resetFilter();
    this.ajaxReload();
  }

  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let listExportsRequestSearch = new ResellerRequestSearch();
    // Search Bar
    listExportsRequestSearch.region = this.searchFilterForm.controls['searchFilterField'].value;
    // Page Number
    listExportsRequestSearch.pageNumber = this.numeroPagina;
    // Page Size
    listExportsRequestSearch.pageSize = this.dimPagina;
    // Select
    if (this.selectedType.length > 0) {
      listExportsRequestSearch.type = this.selectedType[0].value;
    }
    return listExportsRequestSearch;
  }

  clickButtonClearFilter() {
    // Search
    this.searchFilterForm.controls.searchFilterField.setValue('');
    // Select
    this.selectedType = [];
    // Checkboxes
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
    })
    this.clickSearch();
  }


  getSettings() {
    this.typeSettings = this._typeSettings();
  }

  /**
 * 
 * @param id Delete document
 */
  delete(id) {
    this.resellerService.delete(id)
      .subscribe(
        (response: any) => {
          
          //Aggiorna tabella
          this.ajaxReload();
          //Togli spinner
          this.spinner.hide();
          //Feedback all'utente
          this.toastr.success('Reseller cancellato con successo', 'Cancella reseller');
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.spinner.hide();
          this.toastr.error('Si è verificato un errore durante la cancellazione del reseller', 'Cancella reseller fallita', {
            timeOut: 5000
          });
        }
      );
  }

  /*  Gestione Azioni tabella */

  clickButtonUpdate(id) {
    //Apertura modale di modifica 
    const modalRef = this.modalService.open(ResellerEditComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.id = id;
    modalRef.result.then((result: ResellerResponse) => {
      if (result) {
        
        this.filterSelect();
      }
    }, (error) => {
      console.log(error);
    });
  }

  choiceButtonResponse($event) {
    if ($event == "CREATE") {
      //Apre modale di create
      const modalRef = this.modalService.open(ResellerCreateComponent, DIALOG_LARGE_CONFIG);
      modalRef.result.then(result => {
        if (result) {
          
          this.filterSelect();
        }
      }, (error) => {
        console.log(error);
      });
    }
  }

  clickButtonDelete(id) {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare il reseller?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          this.delete(id);
        }
      }
    }, (error) => {
      console.log(error);
    });
  }

}
